// import { CardStackVideoSlider } from "@/components/cardstackvideoslider"
import { Button } from "@/components/ui/button"
import Hero from '@/components/public/Hero';
import EventCountdown from '@/components/public/EventCountdown';
// import Gallery from "@/components/Gallery"
import Speakers from '@/components/public/Speakers';
import InfoCards from "@/components/public/InfoCards"
// import Documents from "@/components/Documents"
import LocationVanue from "@/components/public/LocationVanue";
import AboutKonaspiXII from "@/components/public/AboutKonaspiXII"
import ConferenceTracks from "@/components/public/ConferenceTracks"
import UniversityPartners from "@/components/public/UniversityPartners"
import InternationalJoinConference from "@/components/public/InternationalJoinConference"
// import { SlideConference } from "@/components/slideconference"
import { SlidePimpinanLPTK } from "@/components/public/SlidePimpinanLPTK"
import { Navigation } from "@/components/public/layout/Navigation"
import { Footer } from "@/components/public/layout/Footer"

// import EventInformation from "@/components/public/EventInformation";
import TimelineSection from "@/components/public/TimelineSection";
import FloatingMenu from "@/components/public/FloatingMenu";
import Hotel from "@/components/public/Hotel";
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";

export default function KonaspiXIILanding() {
  const { t } = useTranslation(['public', 'common']); // Gunakan namespace public & common
  return (
    <div className="min-h-screen bg-background">
      <div id="home"></div>
      {/* Navigasi */}
      <Navigation />

      {/* Hero */}
      <Hero />

      {/* Countdown & Info Penting */}
      <EventCountdown />

      {/* InfoCards */}
      <InfoCards />

      {/* About Section */}
      <AboutKonaspiXII />

      {/* University Partners Section */}
      <UniversityPartners />

      {/* Speakers Section */}
      <Speakers />

      {/* Pimpinan LPTK */}
      <SlidePimpinanLPTK />

      {/* Slide Conference */}
      {/* <SlideConference /> */}

      {/* Interactive Demo Section */}
      <InternationalJoinConference />

      {/* Conference */}
      <ConferenceTracks />

      {/* Timeline Section - Table Format */}
      <TimelineSection />

      {/* Event Information Section */}
      {/* <EventInformation /> */}

      {/* Location & Venue Information Section */}
      <LocationVanue />

      {/* Hotel */}
      <Hotel />

      {/* Documents Section */}
      {/* <Documents /> */}

      {/* Gallery Section */}
      {/* <Gallery /> */}

      {/* Tagline Section */}
      <section className="py-16 bg-secondary/10">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h3 className="text-3xl font-bold text-primary mb-4">
              {t('public:cta.tagline_quote')}
            </h3>
            <p className="text-xl text-foreground font-medium">
              {t('public:cta.tagline_sub')}
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section - "Bergabung dengan Transformasi Pendidikan" */}
      <section className="py-20 bg-primary text-primary-foreground">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">
              {t('public:cta.title')}
            </h2>
            <p className="text-xl mb-8 opacity-90">
              {t('public:cta.description')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/registration/convention" className="flex items-center justify-center gap-2 px-8 py-2 bg-secondary hover:bg-dark dark:bg-yellow-500 text-white font-semibold rounded-sm w-full sm:w-auto">
                {t('public:hero.buttons.register_convention')}
              </Link>
              <Button size="lg" variant="outline" className="border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary bg-transparent" onClick={() => (window.location.href = "#conference-tracks")}>
                {t('public:hero.buttons.register_conference')}
              </Button>
              {/* <Button
                size="lg"
                variant="outline"
                className="border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary bg-transparent"
              >
                Download Proposal
              </Button> */}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />

      <FloatingMenu />
    </div>
  )
}
